import { BaseApiModel } from 'app/models/api/response';

export class ProvinceAddressComponent extends BaseApiModel {
    name?: string;
    default?: boolean;
}
